<template>
    <div>
        <div class="card">
            <div class="card-body">

                <div class="d-flex justify-content-between article-top-header">
                    <!-- <small class="text-secondary-color">{{ created_by }}</small> -->
                    <small class="text-secondary-color">{{ date_created }}</small>
                </div>

                <div class="article-title text-white mt-4">
                    <h2 class="header-text-regular">{{ title }}</h2>
                </div>

                <div class="articles-content mt-4 text-white">
                    <p v-html="content"></p>
                </div>

                <div class="mt-4">
                    <router-link :to="`/articles/${date_link}/${dash}/${mask}`" class="text-white">read more</router-link>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Articles',
    props: [
        'created_by',
        'date_created',
        'date_link',
        'title',
        'content',
        'mask',
        'dash'
    ]
};
</script>



// WEBPACK FOOTER //
// src/components/frontend/articles/Articles.vue